import { Component, Inject, ViewChild, ElementRef, OnInit } from '@angular/core';
import { FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatSelectionList, MatListOption } from '@angular/material';
import { CotizacionService } from '../../../providers/cotizacion.service';
import { AuthenticationService } from '../../../providers/auth.service';
import { Contacto } from '../../../interfaces/contacto';
import { Globals } from '../../../globals';
import { GeneralService } from '../../../providers/general.service';

@Component({
  selector: 'app-email-cotizacion-dialog',
  templateUrl: './email-cotizacion-dialog.component.html',
  styleUrls: ['./email-cotizacion-dialog.component.scss']
})
export class EmailCotizacionDialog implements OnInit {
  error: string = '';
  cargando: boolean = true;
  firmarEmail: boolean = true;
  imagenesFirma: string[] = [];

  @ViewChild('dialogContent') dialogContent: ElementRef;
  @ViewChild('destinatarios') destinatarios: MatSelectionList;

  private customEmailValidator(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }

    return Validators.email(control);
  }

  emailFormControl = new FormControl('', [
    this.customEmailValidator
  ]);
  asuntoFormControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(200)
  ]);
  comentarioFormControl = new FormControl('', []);
  invalido: boolean = true;

  constructor(
    public dialogEmail: MatDialogRef<EmailCotizacionDialog>,
    public cotizacionService: CotizacionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public authService: AuthenticationService,
    public globals: Globals,
    public general: GeneralService
  ) { }

  ngOnInit() {
    this.asuntoFormControl.valueChanges.subscribe(
      () => {
        this.checkFormValido();
      }
    );

    // this.globals.firma_email_imagenes.forEach(imagen => {
    //   this.imagenesFirma.push(this.globals.webadmin + 'assets/email/firma/' + this.globals.empresa.toLowerCase() + '/' + imagen);
    // });
    this.general.firma_email_imagenes.forEach(imagen => {
      //console.log(imagen);
      this.imagenesFirma.push(imagen.base64);
    });
  }

  checkFormValido() {
    this.invalido = this.destinatarios.selectedOptions.selected.length < 1 ||
      this.asuntoFormControl.hasError('maxlength') ||
      this.asuntoFormControl.hasError('required');
  }

  agregarDestinatario(): void {
    if (this.emailFormControl.value && !this.emailFormControl.hasError('email')) {
      this.data.contactos.push(<Contacto>{
        email: this.emailFormControl.value
      });

      this.emailFormControl.setValue(null);

      setTimeout(() => {
        this.checkFormValido();
      }, 0);
    }
  }

  onCancelar(): void {
    this.dialogEmail.close();
  }

  onEnviar(): void {
    var destinatarios = this.destinatarios.selectedOptions.selected.map((opcion: MatListOption) => {
      return opcion.value;
    });

    this.cargando = true;
    this.cotizacionService.enviarEmailCotizacion(
      this.asuntoFormControl.value,
      destinatarios,
      this.comentarioFormControl.value,
      document.getElementById('firma') ? document.getElementById('firma').innerHTML : "",
      this.data.pdf,
      this.data.footer,
      this.data.IdCotizacion,
      this.data.IdFormateado
    ).subscribe(
      respuesta => {
        if (respuesta) {
          if (respuesta.estado == 1) {
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: 6750 });
            this.dialogEmail.close();
          } else {
            this.error = respuesta.mensaje;
          }
        } else {
          this.error = "Ocurrió un error al enviar el email";
        }

        this.cargando = false;
      },
      () => {
        this.error = "Ocurrió un error al enviar el email";
        this.cargando = false;
      }
    );
  }
}
